import { useTranslation } from '@wlb/shared/i18n/useTranslation';
import { PageHeader } from '../components/layout/PageHeader';
import { UserStatistics } from '../features/users/UserStatistics';
import './pages.css';

/**
 * Member engagement ranking. The dashboard answers "how is the community
 * doing"; this answers "who is driving it", which is a different question and
 * a different endpoint (`Admin/User/Statistics`).
 */
export function Statistics() {
  const { t } = useTranslation('admin');

  return (
    <div className="page page--fill">
      <PageHeader
        title={t('statistics.title')}
        subtitle={t('statistics.subtitle')}
      />
      <UserStatistics />
    </div>
  );
}
